<template>
  <section
    :class="[
      'bg-linear-to-b from-primary-50 to-white pt-12 lg:pt-20',
      {
        'pb-16 lg:pb-24': !noPaddingBottom,
      },
    ]"
  >
    <TContainer>
      <div class="grid gap-10 lg:grid-cols-2 lg:items-center">
        <AppHeaderLogo
          :to="localePath({ name: 'index' })"
          class="lg:hidden flex justify-center mx-auto w-fit"
        />

        <div
          :class="['text-center lg:text-left space-y-6', {
            'mb-12': noPaddingBottom,
          }]"
        >
          <slot name="pre-title">
            <TMarketingPreTitle v-if="preTitle">
              {{ preTitle }}
            </TMarketingPreTitle>
          </slot>

          <THeadingMarketing
            v-if="titleKeypath"
            :level="1"
          >
            <I18nT
              :keypath="titleKeypath"
              tag="span"
            >
              <template #highlight>
                <span
                  :class="['text-secondary', {
                    block: isHighlightedTitleBlock,
                  }]"
                >{{ highlightedTitle }}</span>
              </template>
            </I18nT>
          </THeadingMarketing>

          <p
            v-if="subtitle"
            class="text-lg max-w-2xl mx-auto lg:mx-0 leading-relaxed"
          >
            {{ subtitle }}
          </p>

          <div
            v-if="$slots?.default"
            class="space-y-4"
          >
            <slot />
          </div>

          <div
            v-if="$slots?.cta"
            class="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start"
          >
            <slot name="cta" />
          </div>

          <div
            v-if="proof"
            class="flex items-center gap-2 justify-center lg:justify-start text-sm text-left"
          >
            <TIcon
              :icon="proof.icon"
              class="text-secondary"
            />
            <span>{{ proof.text }}</span>
          </div>
        </div>

        <div :class="{ 'self-end': noPaddingBottom }">
          <slot name="image" />
        </div>
      </div>
    </TContainer>
  </section>
</template>

<script setup lang="ts">
import type { IconProp } from '@fortawesome/fontawesome-svg-core'

defineProps<{
  preTitle?: string
  titleKeypath?: string
  highlightedTitle?: string
  subtitle?: string
  proof?: {
    text: string
    icon: IconProp
  }
  noPaddingBottom?: boolean
  isHighlightedTitleBlock?: boolean
}>()

const localePath = useLocalePath()
</script>
